import React, { useEffect, useState } from 'react';
import { Button, Stack } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { TimePeriodSelector } from 'utils/TimePeriodSelector';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { CheckForTodayEnabled } from 'Global/Functions/CheckForTodayEnabled';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import DateRangePicker from 'Global/Components/CommonComponents/DateRangePicker/DateRangePicker';
import i18next from 'i18next';
import { GetCurrentDateInJalai } from 'utils/GetCurrentDateInJalai';
import moment from 'moment-jalaali';

const DateRanges = ({ setRange }) => {
  const next30DaysMsg = FindLangKey(
    'get-new-turn-select-this-month'
  );
  const next7DaysMsg = FindLangKey(
    'get-new-turn-select-this-week'
  );
  const tomorrowMsg = FindLangKey(
    'get-new-turn-select-tommorow'
  );

  const today_Message = FindLangKey(
    'get-new-turn-select-this-today-date'
  );

  const selectTimeMsg = FindLangKey(
    'get-new-turn-select-time-period'
  );

  const [dateRange, setDateRange] = useState(null);

  const [dateModeSelect, setDateModeSelect] =
    useState(null);

  const [userRange, setUserRange] = useState(false);

  const isTodayEnabled = CheckForTodayEnabled();

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  useEffect(() => {
    if (dateRange) setRange(dateRange);
  }, [dateRange]);

  // console.log(
  //   'dateRangedateRangedateRangedateRange=>',
  //   dateRange
  // );

  const tenDayAdded = moment(
    GetCurrentDateInJalai(),
    'jYYYY/jMM/jDD'
  )
    .add(10, 'days')
    .format('YYYY/MM/DD');

  return (
    <React.Fragment>
      <Stack
        gap=".5em"
        display={screenWidth > 1024 ? 'grid' : ''}
        sx={{
          gridTemplateColumns:
            screenWidth > 1024
              ? 'repeat(2, 1fr) !important'
              : '',
          direction:
            i18next.language === 'fa' ||
            i18next.language === 'ar'
              ? 'rtl'
              : 'ltr',
        }}
      >
        {isTodayEnabled ? (
          <Button
            color="colorPrimer"
            fullWidth
            variant="contained"
            sx={{
              minHeight: '40px',
              color:
                dateModeSelect === -1
                  ? `${themeColors.ColorSecondary} !important`
                  : `${themeColors.ColorPrimary} !important`,
              backgroundColor:
                dateModeSelect === -1
                  ? `${themeColors.ColorPrimary} !important`
                  : '',
            }}
            onClick={() => {
              setDateRange(TimePeriodSelector('today'));
              setDateModeSelect(-1);
              setUserRange(false);
            }}
          >
            {today_Message}
          </Button>
        ) : (
          <></>
        )}

        <Button
          color="colorPrimer"
          fullWidth
          variant="contained"
          sx={{
            minHeight: '40px',
            color:
              dateModeSelect === 0
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              dateModeSelect === 0
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            setDateRange(TimePeriodSelector('tom'));
            setDateModeSelect(0);
            setUserRange(false);
          }}
        >
          {tomorrowMsg}
        </Button>
        <Button
          color="colorPrimer"
          fullWidth
          variant="contained"
          sx={{
            minHeight: '40px',
            color:
              dateModeSelect === 1
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              dateModeSelect === 1
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            setDateRange(TimePeriodSelector('week'));
            setDateModeSelect(1);
            setUserRange(false);
          }}
        >
          {next7DaysMsg}
        </Button>
        <Button
          color="colorPrimer"
          fullWidth
          variant="contained"
          sx={{
            minHeight: '40px',
            direction: 'rtl',
            color:
              dateModeSelect === 2
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              dateModeSelect === 2
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            setDateRange(TimePeriodSelector('month'));
            setDateModeSelect(2);
            setUserRange(false);
          }}
        >
          {next30DaysMsg}
        </Button>
        <Button
          color="colorPrimer"
          fullWidth
          variant="contained"
          sx={{
            minHeight: '40px',
            color:
              dateModeSelect === 3 && userRange
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              dateModeSelect === 3 && userRange
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            setDateModeSelect(3);
            setUserRange((prev) => !prev);
          }}
        >
          {selectTimeMsg}
        </Button>

        {/* {typeof dateRange !== 'boolean' &&
        dateRange !== null ? (
          <Button
            variant="outlined"
            disabled
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
          >
            {dateRange?.FromDate}   {dateRange?.ToDate}
          </Button>
        ) : (
          <></>
        )} */}
      </Stack>
      {userRange ? (
        <Stack
          sx={{
            width: '100%',
          }}
        >
          <DateRangePicker
            GetDateRange={setDateRange}
            initialValue={{
              FromDate: GetCurrentDateInJalai(),
              ToDate: moment(
                tenDayAdded,
                'YYYY-MM-DD'
              ).format('jYYYY/jMM/jDD'),
            }}
            lockToday={true}
            LockToGreaterThanFrom={true}
          />
        </Stack>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default DateRanges;
